import React from "react"
import { Table } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import { fillingZeroUtility, formatCurrency } from "../../../lib/utils"
import { browserHistory } from "react-router"
import moment from "moment"
import AlertModal from "../../fragments/AlertModal"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { blockingFetchService } from "../../../lib/blockingFetch"
import CaptionTable from "../../fragments/CaptionTable"

const className = 'cursor-pointer',
title = 'Show details'

export default class BatchLoans extends React.Component {

  state = {
    loanId: null,
    running: false,
    success: false,
    error: null,
  }

  unlinkLoan = loanId => this.setState({
    loanId,
    running: false,
    success: false,
    error: null,
  })

  confirmForm = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { batchId, setFinancierBatch } = this.props,
    { loanId } = this.state

    blockingFetchService(
      accessToken => apiServerApi.removeLoanFinancierBatch(accessToken, batchId, loanId),
      resp => {
        this.setState({ success: true })
        setTimeout(this.closeForm, 1000)
        setFinancierBatch(batchId, resp)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeForm = () => this.setState({ loanId: null })

  renderConfirmContent = () => {
    const { running, success, error } = this.state
    return (
      <div>
        <h3>Do you really want to unlink this loan?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderThs = isLarge => <tr>

    { isLarge && <th>Disbursed on</th> }

    <th>Bundle</th>

    { isLarge && <th>Currency code</th> }

    <th>Purchase cost</th>
    <th>Selling price</th>
  
    { isLarge && <th>Status</th> }

    <th className="align-center">Action</th>
  </tr>

  getData = (loans, isLarge, batchClosed) => loans
    .map(({ id, bundleQty, bundleName, status, purchaseCost, sellingCost, disburseDate, 
    currencyCode }, index) => {

    const onClick = () => browserHistory.push(`/loans/${ id }/detail`)

    return <tr key={`small-loan-${index}`} title={ title } className={ className }>

      { isLarge && <td onClick={ onClick }>
        <small>{ moment(disburseDate).format('ll') }</small></td> }

      <td onClick={ onClick }>{ fillingZeroUtility(bundleQty) } x { bundleName }</td>

      { isLarge && <td onClick={ onClick }>{ currencyCode }</td> }

      <td onClick={ onClick }>{ formatCurrency(purchaseCost) }</td>
      <td onClick={ onClick }>{ formatCurrency(sellingCost) }</td>

      { isLarge && <td onClick={ onClick }>
        <small className="gray">{ status }</small></td> }

      <td className="align-center">
        { !batchClosed && <span className="red cursor-pointer p-5" title="Unlink this loan!"
          onClick={() => this.unlinkLoan(id) }>
          <FontAwesome name='trash' />
        </span>}
      </td>
    </tr>
  })

  render() {

    const { loans, isLarge, closed } = this.props
    if(!loans || !loans.length) return null

    const { loanId, running } = this.state

    return (
      <div>
 
        <Table striped condensed hover responsive>

          <CaptionTable text={`Loans (${ fillingZeroUtility(loans.length) })`} />

          <tbody>
            { this.renderThs(isLarge) }
            { this.getData(loans, isLarge, closed) }
          </tbody>
        </Table>

        <AlertModal
          show={ loanId != null }
          title="Unlink loan"
          body={ this.renderConfirmContent() }
          bsStyle="danger"
          close={ this.closeForm }
          confirm={ this.confirmForm }
          proceedText="Unlink"
          disabled={ running }
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Batches/BatchLoans.js